import React, { useState, useEffect, useCallback, useRef } from "react";
import { motion } from "framer-motion";

// images
import puzzleLogo from "../images/puzzle_logo.svg";
import puzzleFrame from "../images/puzzle_frame.png";

const puzzleDataImages = [
  [
    { id: 1, src: "../images/puzzle/level-1/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-1/image_2.png", oddOneOut: true },
    { id: 3, src: "../images/puzzle/level-1/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-1/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-1/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-1/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-2/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-2/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-2/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-2/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-2/image_5.png", oddOneOut: true },
    { id: 6, src: "../images/puzzle/level-2/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-3/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-3/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-3/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-3/image_4.png", oddOneOut: true },
    { id: 5, src: "../images/puzzle/level-3/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-3/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-4/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-4/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-4/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-4/image_4.png", oddOneOut: true },
    { id: 5, src: "../images/puzzle/level-4/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-4/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-5/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-5/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-5/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-5/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-5/image_5.png", oddOneOut: true },
    { id: 6, src: "../images/puzzle/level-5/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-6/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-6/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-6/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-6/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-6/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-6/image_6.png", oddOneOut: true },
  ],
  [
    { id: 1, src: "../images/puzzle/level-7/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-7/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-7/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-7/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-7/image_5.png", oddOneOut: true },
    { id: 6, src: "../images/puzzle/level-7/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-8/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-8/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-8/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-8/image_4.png", oddOneOut: true },
    { id: 5, src: "../images/puzzle/level-8/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-8/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-9/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-9/image_2.png", oddOneOut: true },
    { id: 3, src: "../images/puzzle/level-9/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-9/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-9/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-9/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-10/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-10/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-10/image_3.png", oddOneOut: true },
    { id: 4, src: "../images/puzzle/level-10/image_4.png", oddOneOut: false },
    { id: 5, src: "../images/puzzle/level-10/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-10/image_6.png", oddOneOut: false },
  ],
  [
    { id: 1, src: "../images/puzzle/level-11/image_1.png", oddOneOut: false },
    { id: 2, src: "../images/puzzle/level-11/image_2.png", oddOneOut: false },
    { id: 3, src: "../images/puzzle/level-11/image_3.png", oddOneOut: false },
    { id: 4, src: "../images/puzzle/level-11/image_4.png", oddOneOut: true },
    { id: 5, src: "../images/puzzle/level-11/image_5.png", oddOneOut: false },
    { id: 6, src: "../images/puzzle/level-11/image_6.png", oddOneOut: false },
  ],
];

// shuffle function
const shuffleArray = (array) => {
  let shuffledArray = array.slice();
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

const puzzleData = shuffleArray(puzzleDataImages);

const isPointInRect = (x, y, rect) =>
  x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;

const Game = ({
  gameData,
  gameSessionData,
  setGameData,
  endGame,
  gameTimeLimit,
  setGameCompleted,
  soundEffects,
}) => {
  const [droppedImage, setDroppedImage] = useState(null);
  // const [isCorrect, setIsCorrect] = useState(null);
  const [currentLevel, setCurrentLevel] = useState(1);
  const [backgroundColour, setBackgroundColour] = useState("");
  const [countdown, setCountdown] = useState(gameTimeLimit / 1000);
  const [shuffledPuzzleData, setShuffledPuzzleData] = useState([]);
  const [gameEnd, setGameEnd] = useState(false); // Used to trigger endGame so that the latest update for "endTime" is registered
  const [activeDrag, setActiveDrag] = useState(null);
  const [isOverDropZone, setIsOverDropZone] = useState(false);
  const dropZoneRef = useRef(null);

  const updateGameData = useCallback(
    (level, key, value) => {
      setGameData((prevData) => {
        const levelKey = `level_${level}`;
        const levelData = prevData[levelKey] || {
          startTime: null,
          endTime: null,
          incorrect: 0,
          correct: 0,
        };
        return {
          ...prevData,
          [levelKey]: {
            ...levelData,
            [key]:
              key === "correct" || key === "incorrect"
                ? levelData[key] + value
                : value,
          },
        };
      });
    },
    [setGameData],
  );

  useEffect(() => {
    const startTime = Date.now();
    updateGameData(currentLevel, "startTime", startTime);
    if (currentLevel > 1) {
      updateGameData(currentLevel - 1, "endTime", startTime);
    }
  }, [currentLevel, updateGameData]);

  useEffect(() => {
    if (countdown <= 0 && !gameSessionData.testing) {
      const endTime = Date.now();
      updateGameData(currentLevel, "endTime", endTime);
      setGameCompleted(true);
      setGameEnd(true);
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [
    countdown,
    currentLevel,
    endGame,
    gameSessionData.testing,
    setGameCompleted,
    updateGameData,
  ]);

  useEffect(() => {
    // Shuffle puzzle data for the current level
    if (puzzleData[currentLevel - 1]) {
      setShuffledPuzzleData(shuffleArray(puzzleData[currentLevel - 1]));
    }
  }, [currentLevel]);

  const loadNextLevel = useCallback(() => {
    const endTime = Date.now();
    updateGameData(currentLevel, "endTime", endTime);

    setTimeout(() => {
      if (currentLevel < puzzleData.length) {
        setDroppedImage(null);
        setShuffledPuzzleData([]); // Clear old images before loading new level

        setCurrentLevel((prev) => prev + 1);
      } else {
        setGameCompleted(true);
        setGameEnd(true);
      }
    }, 2000);
  }, [currentLevel, setGameCompleted, updateGameData]);

  useEffect(() => {
    if (gameEnd) {
      endGame();
    }
  }, [endGame, gameEnd]);

  const isOverDropTarget = useCallback((clientX, clientY) => {
    const dropZone = dropZoneRef.current;

    if (!dropZone) {
      return false;
    }

    return isPointInRect(clientX, clientY, dropZone.getBoundingClientRect());
  }, []);

  const handleImageDrop = useCallback(
    (item) => {
      setBackgroundColour("");
      soundEffects.puzzleDrop.play();
      setDroppedImage(item);
      setTimeout(() => {
        if (item.oddOneOut) {
          soundEffects.correct.play();
          setBackgroundColour("bg-green-500/40");
          updateGameData(currentLevel, "correct", 1);
          loadNextLevel();
        } else {
          soundEffects.incorrect.play();
          updateGameData(currentLevel, "incorrect", 1);
          setBackgroundColour("bg-red-500/40");
        }
      }, 500);
    },
    [currentLevel, loadNextLevel, soundEffects, updateGameData],
  );

  useEffect(() => {
    if (!activeDrag) {
      return undefined;
    }

    const handlePointerMove = (event) => {
      if (event.pointerId !== activeDrag.pointerId) {
        return;
      }

      event.preventDefault();
      const nextX = event.clientX - activeDrag.offsetX;
      const nextY = event.clientY - activeDrag.offsetY;

      setActiveDrag((prevDrag) =>
        prevDrag
          ? {
              ...prevDrag,
              x: nextX,
              y: nextY,
            }
          : prevDrag,
      );
      setIsOverDropZone(isOverDropTarget(event.clientX, event.clientY));
    };

    const handlePointerEnd = (event) => {
      if (event.pointerId !== activeDrag.pointerId) {
        return;
      }

      event.preventDefault();
      const droppedOnTarget = isOverDropTarget(event.clientX, event.clientY);
      const { image } = activeDrag;

      setActiveDrag(null);
      setIsOverDropZone(false);

      if (droppedOnTarget) {
        handleImageDrop(image);
      }
    };

    window.addEventListener("pointermove", handlePointerMove, {
      passive: false,
    });
    window.addEventListener("pointerup", handlePointerEnd, {
      passive: false,
    });
    window.addEventListener("pointercancel", handlePointerEnd, {
      passive: false,
    });

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      window.removeEventListener("pointerup", handlePointerEnd);
      window.removeEventListener("pointercancel", handlePointerEnd);
    };
  }, [activeDrag, handleImageDrop, isOverDropTarget]);

  useEffect(() => {
    setActiveDrag(null);
    setIsOverDropZone(false);
  }, [currentLevel]);

  const handleDragStart = useCallback(
    (event, image) => {
      if (!event.isPrimary) {
        return;
      }

      if (typeof event.button === "number" && event.button !== 0) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const rect = event.currentTarget.getBoundingClientRect();
      event.currentTarget.setPointerCapture?.(event.pointerId);
      soundEffects.puzzlePickUp.play();

      setActiveDrag({
        image,
        pointerId: event.pointerId,
        offsetX: event.clientX - rect.left,
        offsetY: event.clientY - rect.top,
        width: rect.width,
        height: rect.height,
        x: rect.left,
        y: rect.top,
      });
      setIsOverDropZone(isOverDropTarget(event.clientX, event.clientY));
    },
    [isOverDropTarget, soundEffects.puzzlePickUp],
  );

  const renderImages = () =>
    shuffledPuzzleData.map((image) => (
      <DraggableImage
        key={image.id}
        image={image}
        isDragging={activeDrag?.image.id === image.id}
        onDragStart={handleDragStart}
      />
    ));

  return (
    <>
      <div className={`container mx-auto px-14 overflow-clip`}>
        <div className="mt-[100px] text-center">
          <span className="font-keania text-white text-[6rem]">
            {countdown}
          </span>
        </div>
        <div key={currentLevel - 1} className="grid grid-cols-3 gap-24 mt-8">
          {shuffledPuzzleData.length > 0 ? (
            renderImages()
          ) : (
            <div className="col-span-3" />
          )}
        </div>
        <img
          src={puzzleLogo}
          alt="Puzzle Logo"
          className="w-2/6 mx-auto my-20"
        />
        <div
          className={`mx-auto transition-colors duration-500 grid grid-cols-3 gap-16`}
        >
          <div
            ref={dropZoneRef}
            className={`transition-colors duration-500 col-start-2 col-span-1 ${
              isOverDropZone ? "scale-[1.02]" : ""
            }`}
          >
            {droppedImage ? (
              <div
                className="h-[320px] inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${puzzleFrame})` }}
              >
                <motion.img
                  key={droppedImage.id}
                  initial={{ scale: 0.9, y: -3 }}
                  exit={{ scale: 0.9, opacity: 0, y: -3 }}
                  animate={{ scale: 0.96, y: -3 }}
                  transition={{ type: "spring", duration: 0.2 }}
                  className={`${backgroundColour} transition-colors duration-400`}
                  src={droppedImage.src}
                  alt="Dropped"
                />
              </div>
            ) : (
              <div
                className="h-[320px] inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${puzzleFrame})` }}
              ></div>
            )}
          </div>
        </div>
        <div className="text-center text-[1.7rem] font-bold w-1/2 mx-auto mt-10">
          <p>
            Drag and drop the symbol that doesn't match the pattern into the box
            above.
          </p>
        </div>
        {gameSessionData.testing && (
          <button
            onClick={() => endGame()}
            className="bg-green-600 font-bold rounded-md text-white px-4 py-2 mt-10"
          >
            End game
          </button>
        )}
      </div>
      {activeDrag && (
        <div
          className="fixed left-0 top-0 z-[200] pointer-events-none"
          style={{
            width: activeDrag.width,
            height: activeDrag.height,
            transform: `translate3d(${activeDrag.x}px, ${activeDrag.y}px, 0)`,
          }}
        >
          <img
            src={activeDrag.image.src}
            alt={`tile-${activeDrag.image.id}`}
            draggable={false}
            className="block w-full h-full select-none opacity-90"
            style={{
              WebkitUserDrag: "none",
              WebkitTouchCallout: "none",
              userSelect: "none",
            }}
          />
        </div>
      )}
    </>
  );
};

const DraggableImage = ({ image, isDragging, onDragStart }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: { delay: (1 * (image.id - 1)) / 8 },
      }} // subtract 1 from image.id so that the first image is already on-screen
      className={`draggable ${isDragging ? "dragging opacity-35" : ""}`}
      style={{ touchAction: "none" }}
      onPointerDown={(event) => onDragStart(event, image)}
      onDragStart={(event) => event.preventDefault()}
      onContextMenu={(event) => event.preventDefault()}
    >
      <img
        src={image.src}
        alt={`tile-${image.id}`}
        draggable={false}
        onDragStart={(event) => event.preventDefault()}
        className="block w-full h-auto pointer-events-none select-none"
        style={{
          WebkitUserDrag: "none",
          WebkitTouchCallout: "none",
          userSelect: "none",
        }}
      />
    </motion.div>
  );
};

export default Game;
